/**
 * Shared Tailwind class strings for the fan auth forms. Centralised
 * so a UI tweak (radius / focus ring color) only edits one file
 * instead of being duplicated across four pages.
 */

export const inputClass =
  'w-full rounded-xl border border-slate-700 bg-slate-950/60 px-3.5 py-2.5 text-sm text-slate-100 placeholder:text-slate-500 transition-colors hover:bg-slate-950/85 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-500/30 disabled:cursor-not-allowed disabled:opacity-60';

export const labelClass = 'mb-1 block text-xs font-medium text-slate-300';

export const primaryButton =
  // Tactile press scale + brand-tinted hover lift.  enabled: prefix on
  // the lift+scale so the disabled state stays inert (matches the
  // admin <Button> base shipped earlier in this loop).
  'w-full rounded-xl bg-violet-500 px-4 py-2.5 text-sm font-medium text-white shadow-lg shadow-violet-500/20 transition enabled:hover:bg-violet-400 enabled:active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-violet-300 disabled:cursor-not-allowed disabled:bg-violet-500/40 disabled:shadow-none';

export const secondaryButton =
  'w-full rounded-xl border border-slate-700 bg-slate-800/60 px-4 py-2.5 text-sm font-medium text-slate-200 transition enabled:hover:bg-slate-800 enabled:active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-violet-500/40 disabled:cursor-not-allowed disabled:opacity-60';

export const errorBox =
  'rounded-xl border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-xs text-rose-300';

export const infoBox =
  'rounded-xl border border-blue-500/30 bg-blue-500/10 px-3 py-2 text-xs text-blue-200';
